import { auth, useAlert, useTheme, useUser } from "capsule"
import React, { useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { StyleSheet, View } from "react-native"
import { Text } from "react-native-paper"

import RegisterPasswordProviderForm, {
  RegisterPasswordProviderValues,
} from "../../components/RegisterPasswordProviderForm"
import currentDateMs from "../../features/hooks/useDateMock"
import { LinkPasswordProviderNS, LoginNS } from "../../features/i18n/constants"
import { updateUserData } from "../../features/models/UserDataFunctions"
import { useMigrationAccount } from "../../features/Providers/MigrationAccountProvider"
const LinkPasswordProviderScreen = () => {
  const { t } = useTranslation(LinkPasswordProviderNS)
  const { t: tLogin } = useTranslation(LoginNS)
  const { showSnack } = useAlert()
  const [loading, setLoading] = useState(false)
  const { userDocRef } = useUser()
  const { setIsMigrating } = useMigrationAccount()
  const handleLinkProvider = async ({ email, password }: RegisterPasswordProviderValues) => {
    setLoading(true)
    try {
      const credential = auth.EmailAuthProvider.credential(email, password)
      const userAuth = auth()
      if (userAuth.currentUser) {
        setIsMigrating?.(true)
        await userAuth.currentUser.linkWithCredential(credential)
        await userAuth.currentUser.unlink("phone")
        await userAuth.currentUser.sendEmailVerification()
        await updateUserData(userDocRef, { passwordLastChangedAt: currentDateMs() })
      }
    } catch (error) {
      switch (error.code) {
        case "auth/email-already-in-use":
          showSnack({ message: tLogin("errors.emailInUse") })
          break
        default:
          showSnack({ message: tLogin("errors.unknown") })
      }
    } finally {
      setLoading(false)
    }
  }
  const {
    dimensions: { spacing },
    colors: {
      surface: { background },
    },
  } = useTheme()

  const { view, title, text } = useMemo(
    () => ({
      view: [styles.view, { backgroundColor: background, paddingVertical: spacing }],
      title: [styles.title, { paddingHorizontal: spacing * 2 }],
      text: [styles.text, { paddingHorizontal: spacing * 2 }],
    }),
    [spacing, background],
  )
  return (
    <View style={view}>
      <Text style={title}>{t("subTitle")}</Text>
      <Text style={text}>{t("caption")}</Text>
      <RegisterPasswordProviderForm
        loading={!loading}
        onSubmit={handleLinkProvider}
        buttonLabel={t("linkButton")}
      />
    </View>
  )
}
const styles = StyleSheet.create({
  view: {
    flex: 1,
    justifyContent: "center",
    gap: 8,
  },
  text: {
    width: "100%",
    textAlign: "left",
  },
  title: {
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "left",
  },
})
export default LinkPasswordProviderScreen
